














































































































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import ALink from 'src/components/common/a-link/a-link.vue';
const name = 'ttam-selection-block';
export default defineComponent({
  name,
  components: { ALink },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    selected: {
      type: Number,
      required: true,
    },
    backgroundColor: {
      type: String,
    },
    title: {
      type: String,
    },
    tips: {
      type: String,
    },
    icon: {
      type: String,
    },
    border: {
      type: Boolean,
    },
    hasLink: {
      type: Boolean,
    },
    link: {
      type: Object,
    },
    isNewPromotion: {
      type: Boolean,
      default: false,
    },
    activeIcon: {
      type: String,
    },
    label: {
      type: String,
    },
    activeColor: {
      type: Boolean,
    },
    maxSize: {
      type: Number,
    },
    shrink: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
    headerOnly: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { blockId, selected } = toRefs(props);
    const ifActive = computed(() => blockId.value === selected.value);
    const headerMarginBottom = props.headerOnly ? '0' : '16px';
    const xsSize = props.shrink ? 12 : 24;
    const iconClass = props.icon ? `${name}-title-only__content_title_icon` : '';
    return {
      name,
      xsSize,
      iconClass,
      ifActive,
      headerMarginBottom,
    };
  },
});
